module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.commend) ? _c('div', {
    staticClass: "container"
  }, [_c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/3e45432c82692d9c2bfa776e9507c285/544242028/544242028.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(10)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[0].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[0].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")]), _vm._v(" "), _c('span', {
    staticClass: "dujia"
  }, [_vm._v("独家")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000vxCRG30GnbT.jpg?max_age=2592000",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(11)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[1].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[1].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/73a3804e1b971cbebc63d99260278136/540058817/540058817.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(12)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[2].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[2].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/ecc06795d3e3879a5717ba93f5cf995e/261998351/261998351.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(13)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[3].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[3].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")]), _vm._v(" "), _c('span', {
    staticClass: "mv"
  }, [_vm._v("MV")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })]), _vm._v(" "), _c('section', [_c('img', {
    attrs: {
      "src": "http://musicdata.baidu.com/data2/pic/8bace09eaa5d8860eb80fd5773d14d3c/540132627/540132627.jpg@s_0,w_180",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlay(14)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[4].remark)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.commend[4].filename)))]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v("SQ")])]), _vm._v(" "), _c('i', {
    staticClass: "showMore",
    on: {
      "click": _vm.showMore
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "actionSheet_wrap"
    }
  }, [_c('div', {
    staticClass: "weui-mask_transparent actionsheet__mask",
    class: {
      'active': _vm.isShowMask
    },
    attrs: {
      "id": "mask"
    },
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.isShowMore
    },
    attrs: {
      "id": "weui-actionsheet"
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, [_c('div', {
    staticClass: "songName"
  }, [_vm._v("歌曲名")]), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("下载")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("分享")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("评论")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("查看歌手")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("歌词海报")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("查看专辑")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_c('span'), _vm._v(" "), _c('p', [_vm._v("背景音乐")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet__action"
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell",
    attrs: {
      "id": "actionsheet_cancel"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("每日为你推荐30首")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cff8578"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xcommend.vue
// module id = 251
// module chunks = 0